import { v4 } from 'uuid';

import { COUNTERTOP_DEFAULT_OVERHANG } from './constants';
import { PanelType } from './enums';
import { RecordData } from '../../helpers-classes';
import { PanelConnectionsData, PanelData, PanelDataIn } from './types';

export const panelData = (dataIn: Partial<PanelDataIn> = null): PanelData => {
	const rd = new RecordData<PanelDataIn>(dataIn);

	// Size can come from top-level (new format) or metadata.size (legacy format from Panel.serialize())
	// Check both locations for backward compatibility
	const size = dataIn?.size ?? (dataIn as { metadata?: { size?: unknown } })?.metadata?.size as PanelData['size'];

	const record: PanelData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		type: rd.useNewOrDefault('type', PanelType.Front),
		label: rd.useNewOrDefault('label', ''),
		size,
		countertopOverhang: rd.useNewOrDefault('countertopOverhang', COUNTERTOP_DEFAULT_OVERHANG),
		isUtilityPanel: rd.useNewOrDefault('isUtilityPanel', false),
		panelItemGroups: dataIn?.panelItemGroups ?? null,
		breakpoints: dataIn?.breakpoints ?? null,
		connections: rd.useNewOrPartial<PanelConnectionsData>('connections', {
			left: null,
			right: null
		})
	};

	return record;
};
